import { render, staticRenderFns } from "./XAutoComplete.vue?vue&type=template&id=db70255c"
import script from "./XAutoComplete.vue?vue&type=script&lang=js"
export * from "./XAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports